import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitPrice'
})
export class UnitPricePipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value == null || !Number.isFinite(value)) {
      return '';
    }

    const [integerPart, fractionPart = ''] = String(value).split('.');
    const truncatedFraction = fractionPart.slice(0, 4);

    return truncatedFraction ? `${integerPart}.${truncatedFraction}` : integerPart;
  }
}
